export enum LoginError {
    None,
    Password,
    Authorization,
    Disabled,
    MFA
}